import { api } from '../../plugins/api';

const getDefaultState = () => {
  return {
    statutEmploi: {
      id: '',
      active: true,
      statutDEmploi: null,
      demandeInscription: '',
      precisionStatut: null,
      complementPrecisionStatut: '',
      dateDebutConges: null,
      dateFinDeCongesSiConnue: null,
      contributionVolontaire: null,
      finissantUniversitaire: false,
      modeDeReglement: null,
      nombreDePaiements: null,
      choix1: false,
      choix2: false,
      choix3: false,
      choix4: false,
      choix5: false,
      choix6: false,
      choix7: false,
      choix8: false,
      choix9: false,
      detenezVousUnBaccOuMaitriseEnTS: false,
      dateObtention: null,
      universite: '',
      assurance: null,
      validerAssurance: false,
      membreDUnAutreOrdre: false,
      specifier: '',
      demandeAdmission: '',
      pp: ''
    }
  }
}

const state = getDefaultState()

const getters = {
  getStatutEmploi: (state) => { return state.statutEmploi },
}

const mutations = {
  setStatutEmploi (state, statutEmploi) {
    state.statutEmploi = statutEmploi
  },
  setStatutEmploiId(state, statutEmploi) {
    state.statutEmploi.id = statutEmploi.id
  },
  updateStateChoix (state, { field, choix }) {
    Object.assign(state.statutEmploi, {
      [field]: choix
    })
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async getStatutEmploiByDemandeInscriptionId ({ commit }, demandeInscriptionId) {
    const response = await api.get(`statutemploi/demandesinscriptions/` + demandeInscriptionId);
    commit("setStatutEmploi", response.data[0] ? response.data[0] : getDefaultState().statutEmploi)
  },
  async getStatutEmploiByContactId ({ commit }, contactId) {
    const response = await api.get(`statutemploi/contacts/` + contactId);
    commit("setStatutEmploi", response.data ? response.data : getDefaultState().statutEmploi)
    return response
  },
  async updateStatutEmploi ({ commit }, statutEmploi) {
    const response = await api.put(`statutemploi`, statutEmploi);
    commit("setStatutEmploi", response.data)
  },
  async createStatutEmploi({ commit }, statutEmploi) {
    statutEmploi.id = null
    const response = await api.post(`statutemploi`, statutEmploi);
    commit("setStatutEmploiId", response.data)
  },
  resetModuleState ({ commit }) {
    commit('resetState')
  },
}

export default ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
})